import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const imageWidth = '9rem'

const useStyles = createUseStyles((t: typeof theme) => ({
  thumb: {
    display: 'block',
    padding: '.85rem .25rem',
    background: t.white,
  },

  image: {
    position: 'relative',
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
    width: imageWidth,
    height: imageWidth,
    background: t.gray04,

    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
    },
  },

  bottom: {
    display: 'block',
    marginTop: '.4rem',
    width: imageWidth,
    padding: '0 0 .1rem .1rem',
    fontSize: '.8rem',
    textAlign: 'left',
  },

  fileName: {
    display: 'block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  productClass: {
    display: 'block',
  },

  icon: {
    display: 'inline-block',
    marginRight: '.3rem',
    fontSize: '.7rem',
  },

  annotationStatus: {
    display: 'block',
  },

  valid: {
    color: '#92c591',
  },

  partial: {
    color: '#e6dda5',
  },

  empty: {
    color: t.red03,
  },

  usedForTrainTest: {
    fontSize: '0.9em',
  },

  tagsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '.2rem',
  },

  iconsRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '0.97em',
    '& > *': {
      transition: 'transform 0.15s ease',
      '&:hover': {
        transform: 'scale(1.6)',
      },
    },
  },
}))

export default useStyles
